import React, { useState, useEffect } from "react";
import QuicksightDashboard from './quicksightDashboard';
import { enableQuicksightDashboard } from "../../config/features";

function Home() {

    let customerNumberLogged = localStorage.getItem('customerNo')
    let roleTypeLogged = localStorage.getItem('role')
    const [customerNumber, setCustomerNumber] = useState(customerNumberLogged);
    const [roleType, setRoleType] = useState(roleTypeLogged);

    return (
        <>
            {enableQuicksightDashboard && roleType!='Vendor' ?
                <>
                    <QuicksightDashboard></QuicksightDashboard>
                </>
                :
                null
            }
        </>


    );

}
export default Home